// „Dobierz do zestawu” w koszyku: wczytuje sections/ab-cart-upsell.liquid, gdy szuflada jest otwarta albo na /cart.
// Szuflada przerysowuje się po każdej zmianie koszyka, więc pilnujemy pustych miejsc [data-ab-upsell] obserwatorem.
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  function visible(el) {
    var d = el.closest('cart-drawer');
    return !d || d.classList.contains('active');
  }

  function load(el) {
    el.setAttribute('data-loading', '');
    fetch(root + '?section_id=ab-cart-upsell', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var box = new DOMParser().parseFromString(html, 'text/html').querySelector('.ab-up-root');
        el.innerHTML = box ? box.innerHTML : '';
      })
      .catch(function () {});
  }

  function scan() {
    document.querySelectorAll('[data-ab-upsell]:not([data-loading])').forEach(function (el) {
      if (visible(el)) load(el);
    });
  }

  new MutationObserver(function () { if (!busy) scan(); }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  scan();

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-ab-up-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    var drawer = document.querySelector('cart-drawer');
    var inDrawer = drawer && b.closest('cart-drawer');
    var body = { items: [{ id: +b.dataset.abUpAdd, quantity: 1, properties: { _z_koszyka: '1' } }] };
    if (inDrawer && drawer.getSectionsToRender) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    busy = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (res) {
        if (inDrawer && res.sections) { drawer.renderContents(res); busy = false; scan(); }
        else window.location.reload();
      })
      .catch(function () { b.disabled = false; busy = false; });
  });
})();
